import {cookieHelper} from '@shopify/marketing-assets';

export function initGdprDrift() {
  const cookieDismissBtn = document.querySelector('.cookies-notice__cta .js-dismiss-btn');

  if (cookieHelper.get('eu_cookies_acknowledged') === '1') {
    driftLoad();
  }

  if (cookieDismissBtn) {
    cookieDismissBtn.addEventListener('click', driftLoad);
  }

  function driftLoad() {
    if ('drift' in window) {
      drift.load('72a698su8tsc');
    }
  }
}
